"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alignItemsHelperStyle = exports.AlignItemsHelperArray = void 0;

var _grid = require("../grid");

var AlignItemsHelperArray = ['flex-start', 'flex-end', 'center', 'baseline', 'stretch', 'inherit', 'initial', 'unset'];
exports.AlignItemsHelperArray = AlignItemsHelperArray;

var alignItemsHelperStyle = function alignItemsHelperStyle(alignItems) {
  return (0, _grid.map)(alignItems, function (b) {
    return "align-items: ".concat(b, " !important;");
  });
};

exports.alignItemsHelperStyle = alignItemsHelperStyle;